import React, { JSX } from 'react'
import { ViewStyle } from 'react-native'
import { SingleValueSlider } from './SingleValueSlider'

export interface SliderMarkerProps {
  currentValue: number
  disabledMarkerStyle?: ViewStyle
  enabled: boolean
  markerStyle: ViewStyle
  pressed: boolean
  pressedMarkerStyle?: ViewStyle
}

export interface SliderStepLabel {
  index: number
  prefix: string
  stepLabel: string | number
  suffix: string
}

export interface SliderProps {
  containerStyle?: ViewStyle
  customMarker?: (props: SliderMarkerProps) => React.ReactNode
  disabledMarkerStyle?: ViewStyle
  enabledOne?: boolean
  markerStyle?: ViewStyle
  max?: number
  min?: number
  onValuesChange?: (values: number[]) => void
  onValuesChangeFinish?: (values: number[]) => void
  onValuesChangeStart?: () => void
  pressedMarkerStyle?: ViewStyle
  progressColor?: ViewStyle
  selectedStyle?: ViewStyle
  showStepLabels?: boolean
  showStepMarkers?: boolean
  showSteps?: boolean
  sliderLength?: number
  step?: number
  stepLabelStyle?: ViewStyle
  stepMarkerStyle?: ViewStyle
  stepsAs?: Array<number | string | SliderStepLabel>
  testID?: string
  trackColor?: ViewStyle
  trackStyle?: ViewStyle
  unselectedStyle?: ViewStyle
  values?: number[]
  wrapperStyle?: ViewStyle
}

export const Slider = ({
  values = [],
  wrapperStyle,
  testID,
  trackColor = {},
  progressColor = {},
  ...sliderProps
}: SliderProps): JSX.Element => {
  return (
    <SingleValueSlider
      {...sliderProps}
      progressColor={progressColor}
      testID={testID}
      trackColor={trackColor}
      values={values}
      wrapperStyle={wrapperStyle}
    />
  )
}
